/**
 * 位置图标
 */
const LocationIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.98991 12.2259C7.98991 12.2259 12.6566 9.17602 12.6566 5.6501C12.6566 3.13586 10.5672 1.09766 7.98991 1.09766C5.41258 1.09766 3.32324 3.13586 3.32324 5.6501C3.32324 9.17602 7.98991 12.2259 7.98991 12.2259Z"
        stroke="#86868B"
        strokeWidth="1.33333"
      />
      <path
        d="M7.99967 7.38021C8.88562 7.38021 9.60384 6.66199 9.60384 5.77604C9.60384 4.89009 8.88562 4.17188 7.99967 4.17188C7.11373 4.17188 6.39551 4.89009 6.39551 5.77604C6.39551 6.66199 7.11373 7.38021 7.99967 7.38021Z"
        stroke="#86868B"
        strokeWidth="1.33333"
        strokeLinejoin="round"
      />
      <path d="M2 12.668V14.668H14V12.668" stroke="#86868B" strokeWidth="1.33333" />
    </svg>
  )
}

export default LocationIcon
